/**
 * Address of the relay server: VITE_INVADERS_SERVER if set; in development (the page served by Vite), port 5080 of the
 * page's host; otherwise the server that served the page (it serves the built game: `pnpm host`), in wss behind https.
 */
export const SERVER_URL: string = (import.meta.env.VITE_INVADERS_SERVER as string | undefined)
  ?? (import.meta.env.DEV ? `ws://${location.hostname}:5080/ws` : `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/ws`);
